import { Route } from 'react-router-dom';
import { ManageRoute } from '../components/auth/ManageRoute.js';
import { CorrectionsPage, LettersPage, ScanApprovalsPage } from '../lazyPages.js';

/* ===========================================================================
 * THE APPROVAL QUEUES' DOORS ON THE MANAGEMENT SURFACE.
 *
 * Two role-gated addresses under `/corrections/approvals` and
 * `/attendance/scan-approvals`, grouped for the reason the retired-paths
 * fragment beside them gives: one group, one reason to change (an approver's
 * way in to a queue), and `App.tsx` is long-standing size debt behind a ratchet
 * that only lets it shrink.
 *
 * A FRAGMENT, not a component — `<Routes>` walks `<React.Fragment>` children
 * for `<Route>` elements but rejects a component that RETURNS them. Splice it
 * in as `{APPROVAL_DOOR_ROUTES}`. Same mechanic, same reason, as
 * `OPERATIONS_RETIRED_PATHS`.
 * ======================================================================== */
export const APPROVAL_DOOR_ROUTES = (
  <>
    {/* THE APPROVER'S DOOR TO THE SAME PAGE.
        `/corrections` is the worker's own screen and is deliberately ungated,
        which is what keeps `isAdminPath` from flipping a worker into the Admin
        panel for visiting it. But that also meant the approval queue — which
        CorrectionsPage opens on for an approver — existed ONLY in the personal
        list, and admin mode renders no personal items. The app's second
        approval queue could not be reached from the Admin panel at all.
        A second path, role-gated, gives the queue a home on the management
        surface without making the worker's own page an admin route. The
        component is the same; only the door is different. */}
    <Route
      path="corrections/approvals"
      element={
        <ManageRoute permission="corrections.approve" feature="corrections">
          <CorrectionsPage />
        </ManageRoute>
      }
    />
    {/* THE SIXTH APPROVAL QUEUE, and unlike the five beside it this one has no
        `feature` gate — deliberately, and for the reason the muster roll
        carries none either: a flagged scan is minted by the punch path itself,
        which every deployment runs. There is no module whose absence would make
        the page meaningless; turning it off would only hide work that still
        exists, and an undecided scan can be sitting outside a day's hours. */}
    <Route
      path="attendance/scan-approvals"
      element={
        <ManageRoute permission="attendance.scans.view" feature="faceRecognition">
          <ScanApprovalsPage />
        </ManageRoute>
      }
    />
    {/* THE SAME DOOR CORRECTIONS ALREADY HAS, and for the
        same reason. `/letters` is ungated so a worker can request a
        letter, which keeps `isAdminPath` from flipping them into
        the Admin panel for visiting it — but that left the letter
        QUEUE reachable only through a tab on a personal-list page,
        and admin mode renders no personal rows. An approver had no
        way to reach the app's fourth approval queue from the
        management surface at all.

        Role-gated, so the rail can carry it under Approvals beside
        Correction requests and Leave approvals. Same component,
        different door: the path is what opens it on the queue. */}
    <Route
      path="letters/approvals"
      element={
        <ManageRoute permission="letters.approve" feature="letters">
          <LettersPage />
        </ManageRoute>
      }
    />
  </>
);
